import { NgTemplateOutlet } from '@angular/common';
import {
	Component,
	computed,
	inject,
	input,
	output,
	ViewEncapsulation,
} from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

import { LinkDirective } from '@valk-nx/core/lib/directives/link/link.directive';

import type { Link } from './link.interface';

@Component({
	encapsulation: ViewEncapsulation.None,
	imports: [LinkDirective, NgTemplateOutlet, RouterLink, RouterLinkActive],
	selector: 'vp-link',
	templateUrl: './link.html',
})
export class LinkComponent {
	private readonly router = inject(Router);

	className = input<string>('');
	link = input.required<Link>();
	type = input<'link' | 'button' | 'link-unstyled'>('link');
	buttonClassName = input<string>('btn btn-primary');
	/** Class routerLinkActive puts on internal links when the route matches. */
	activeClass = input('');
	activeMatchOptions = input<{ exact: boolean }>({ exact: false });

	linkClick = output<void>();

	// routerLinkValue returns as string to avoid encoding issues
	routerLinkValue = computed<string>(() => {
		const url = decodeURIComponent(this.link().url);

		// Handle relative paths
		if (url.startsWith('./') || url.startsWith('../')) {
			return url;
		}

		// Handle absolute paths starting with /
		if (url.startsWith('/')) {
			return url;
		}

		// Handle root paths (prepend /)
		return '/' + url;
	});

	setHash(hash: string): void {
		// This is a workaround for the fact that the routerLink directive does not support hashes.
		this.router.navigateByUrl(this.router.url + hash);
		/* v8 ignore start */
		setTimeout(() => {
			window.location.reload();
		});
		/* v8 ignore stop */
	}
}
